import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CustomTable from "../../common/CustomTable";
import Orders from "../orders/Orders";
import { useSelector, useDispatch } from "react-redux";
import { replaceUrlParam } from "../../common/utils";
import {
  fetchOrderProductsPurchaseOrders,
  fetchMoreOrderProductsPurchaseOrders,
  selectPurchaseOrders,
  getFullList,
  resetOrderProducts,
} from "./purchaseOrdersSlice";
import {
  fetchOrderByID,
  setOrder,
} from "../orders/ordersSlice";
import Grid from "@material-ui/core/Grid";
import { fetchClients, selectClients } from "../clients/clientsSlice";
// import {fetchOrderUserByID} from '../users/usersSlice';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function PurchaseOrdersContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [purchaseorderNames, setPurchaseOrderNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  // const edit = props.location.pathname.includes("edit");
  const {
    purchaseOrder,
    error,
    loading,
    purchaseOrdersList,
    orderProductsList,
    lastQuery,
    purchaseOrdersAmount,
  } = useSelector(selectPurchaseOrders);
  const { clients, clientsList } = useSelector(selectClients);

  const [numberShown, setNumberShown] = useState(50);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const rowsPerPageOptions = [10, 25, 50];

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [client, setClient] = useState("");
  const [dateBefore, setDateBefore] = useState("");
  const [dateAfter, setDateAfter] = useState("");
  const [searchTerm, setSearchTerm] = useState([]);

  const urlParams = new URLSearchParams(window.location.search);

  const [statusNames, setStatusNames] = useState(["Processing"]);
  const [statusIDs, setStatusIDs] = useState([24]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 5, value: "Pending", name: "Pending" },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 23, value: "Refunded", name: "Refunded" },
    { id: 24, value: "Processing", name: "Processing" },
  ]);

  const invoiceParam = urlParams.get("invoice");

  useEffect(() => {
    dispatch(fetchClients({ token: jwtToken, query: "" }));
    dispatch(resetOrderProducts());
  }, []);

  // const purchaseOrderParam = urlParams.get("purchaseOrder");

  useEffect(() => {
    if (invoiceParam) {
      dispatch(
        fetchOrderProductsPurchaseOrders({
          token: jwtToken,
          // invoiceID: invoiceParam,
          query: `?onlywithpo=true&invoiceid=${
            invoiceParam != null ? invoiceParam : ""
          }&sort=desc&limit=${rowsPerPage}`,
        })
      );
    }
  }, [invoiceParam]);

  const headCells = [
    {
      id: "orderID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Order #",
      long: false,
      sortable: true,
    },
    {
      id: "invoiceID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Invoice #",
      long: false,
      sortable: true,
    },
    {
      id: "xeroPODetails",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Xero PO No.",
      long: false,
      object: true,
      objectProperty: "PurchaseOrders",
      nestedObject: true,
      nestedObjectProperty: "PurchaseOrderNumber",
    },
    {
      id: "userDisplayName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member Name",
      long: false,
    },
    {
      id: "userCode",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "User Code",
      long: false,
    },
    {
      id: "userEmail",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member Email",
      long: false,
    },
    {
      id: "userMobile",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member Mobile No.",
      long: false,
    },
    {
      id: "deliveryAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Company Name",
      long: false,
      object: true,
      objectProperty: "companyName",
    },
    {
      id: "deliveryAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Street Name",
      long: false,
      object: true,
      objectProperty: "streetName",
    },
    {
      id: "deliveryAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Suburb",
      long: false,
      object: true,
      objectProperty: "suburb",
    },
    {
      id: "deliveryAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Post Code",
      long: false,
      object: true,
      objectProperty: "postCode",
    },
    {
      id: "deliveryAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "City",
      long: false,
      object: true,
      objectProperty: "city",
    },
    {
      id: "deliveryAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "State",
      long: false,
      object: true,
      objectProperty: "state",
    },
    {
      id: "deliveryAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Country",
      long: false,
      object: true,
      objectProperty: "country",
    },
    {
      id: "statusName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Status",
      long: false,
    },
    // {
    //   id: "statusID",
    //   checked: true,
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Status ID",
    //   long: false,
    // },
    {
      id: "productName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Product Name",
      long: false,
    },
    {
      id: "productSKU",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Product SKU",
      long: false,
    },
    {
      id: "quantity",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Quantity",
      long: false,
    },
    {
      id: "unitFreight",
      checked: true,
      numeric: true,
      disablePadding: false,
      label: "Unit Freight",
      long: false,
    },
    {
      id: "totalFreight",
      checked: true,
      numeric: true,
      disablePadding: false,
      label: "Total Freight",
      long: false,
    },
    {
      id: "unitPrice",
      checked: true,
      numeric: true,
      disablePadding: false,
      label: "Unit Price",
      long: false,
    },
    {
      id: "unitPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Unit Points",
      long: false,
    },
    {
      id: "totalPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Total Points",
      long: false,
    },
    {
      id: "unitCostPrice",
      checked: true,
      numeric: true,
      disablePadding: false,
      label: "Unit Cost Price",
      long: false,
    },
    {
      id: "totalCostPrice",
      checked: true,
      numeric: true,
      disablePadding: false,
      label: "Total Cost Price",
      long: false,
    },
    {
      id: "unitRRP",
      checked: true,
      numeric: true,
      disablePadding: false,
      label: "Total RRP",
      long: false,
    },
    {
      id: "supplierName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Supplier Name",
      long: false,
      sortable: true,
    },
    {
      id: "deliveryNotes",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Delivery Notes",
      long: false,
      sortable: true,
    },
    {
      id: "notes",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Notes",
      long: false,
      sortable: true,
    },
    {
      id: "courierTrackingURL",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Tracking Link",
      long: true,
    },
    {
      id: "createdAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Order Date",
      long: false,
      sortable: true,
    },
    {
      id: "updatedAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Update",
      long: false,
      sortable: true,
    },
    {
      id: "clientName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Client Name",
      long: false,
    },
    {
      id: "ordersByOrderProduct",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "View Related Orders",
      long: false,
    },
    {
      id: "invoicesByOrderProduct",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "View Related Invoices",
      long: false,
    },
  ];

  // const handleOrdersChange = (event) => {
  //   let idsArr = [];
  //   // event.target.value.forEach((selected) => {
  //   let selectedOrder = ordersList.filter(
  //     (order) => order.orderNumber === event.target.value
  //   );
  //   selectedOrder && idsArr.push(selectedOrder[0].id);
  //   // });

  //   setOrderNames(event.target.value);
  //   setUserIDs(idsArr);
  // };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  // const handleChange = (event) => {
  //   setClient(event.target.value);
  //   let searchQuery = `?onlywithpo=true&limit=${rowsPerPage}`;

  //   if (rowsPerPage) {
  //     searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
  //   }

  //   searchQuery = replaceUrlParam(searchQuery, "clients", event.target.value);

  //   dispatch(
  //     fetchOrderProductsPurchaseOrders({
  //       token: jwtToken,
  //       query: searchQuery,
  //       // query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
  //     })
  //   );

  //   setNumberShown(rowsPerPage);
  // };

  const handleEdit = (id) => {};

  const handleEditClick = (id) => {
    const selectedPurchaseOrder = orderProductsList.find(
      (purchaseOrder) => purchaseOrder.id === id
    );
    if (selectedPurchaseOrder) {
      dispatch(setOrder(selectedPurchaseOrder));
      dispatch(
        fetchOrderByID({
          orderID: selectedPurchaseOrder.orderID,
          token: jwtToken,
        })
      );
    }
  };

  useEffect(() => {
    if (client) {
      let searchQuery = lastQuery ? lastQuery : "";

      if (rowsPerPage) {
        searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
      }

      dispatch(
        fetchOrderProductsPurchaseOrders({
          token: jwtToken,
          query: searchQuery,
        })
      );

      setNumberShown(rowsPerPage);
    }
  }, [rowsPerPage]);

  // useEffect(() => {
  //   let searchQuery = lastQuery ? lastQuery : "";

  //   if (rowsPerPage) {
  //     searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
  //   }

  //   if (invoiceParam) {
  //     searchQuery = replaceUrlParam(searchQuery, "invoiceid", invoiceParam);
  //   }
  //   dispatch(
  //     fetchOrderProductsPurchaseOrders({
  //       token: jwtToken,
  //       query: lastQuery
  //         ? searchQuery
  //         : `?onlywithpo=true&order_by=created_at&sort=desc&statuses=24&limit=${rowsPerPage}`,
  //     })
  //   );

  //   setNumberShown(rowsPerPage);
  // }, [dispatch, rowsPerPage]);

  const handleChange = (event) => {
    setClient(event.target.value);
    let searchQuery = `?onlywithpo=true&statuses=24&limit=${rowsPerPage}`;

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }

    if (invoiceParam) {
      searchQuery = replaceUrlParam(searchQuery, "invoiceid", rowsPerPage);
    }

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    searchQuery = replaceUrlParam(searchQuery, "clients", event.target.value);

    searchQuery = replaceUrlParam(searchQuery, "order_by", "created_at");

    searchQuery = replaceUrlParam(searchQuery, "sort", "desc");

    dispatch(
      fetchOrderProductsPurchaseOrders({
        token: jwtToken,
        query: searchQuery,
      })
    );
    setSortDirection("desc");
    setSortProperty("created_at");

    setNumberShown(rowsPerPage);
  };

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > orderProductsList.length
            ? rowsPerPage
            : orderProductsList.length,
        query: searchQuery,
        targetLength: purchaseOrdersAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        orderProductsList.length < purchaseOrdersAmount &&
        orderProductsList.length < expectedLen
      ) {
        dispatch(
          fetchMoreOrderProductsPurchaseOrders({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (orderProductsList.length == purchaseOrdersAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
      case "totalPoints":
        property = "total_points";
        break;
      case "clientID":
        property = "client_id";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchOrderProductsPurchaseOrders({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {
    let daterange = "";
    if (dateBefore && dateAfter) {
      daterange = `${dateAfter.toISOString().substring(0, 10)},${dateBefore
        .toISOString()
        .substring(0, 10)}`;
    } else if (dateBefore && !dateAfter) {
      daterange = `lte,${dateBefore.toISOString().substring(0, 10)}`;
    } else if (!dateBefore && dateAfter) {
      daterange = `gte,${dateAfter.toISOString().substring(0, 10)}`;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (daterange) {
      searchQuery = replaceUrlParam(searchQuery, "odate", daterange);
    }
    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "invoiceid", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchOrderProductsPurchaseOrders({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setDateAfter("");
    setDateBefore("");
    setClient("");
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchOrderProductsPurchaseOrders({
        token: jwtToken,
        query: `?onlywithpo=true&limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const selectNames = ["status"];

  const [rowList, setRowList] = useState([...headCells]);

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded" || loading === "idle") {
    content = (
      <CustomTable
        data={orderProductsList}
        actionsLists={[statusList]}
        actionsHandleChange={[handleStatusChange]}
        actionsNames={[statusNames]}
        headCells={headCells}
        cellList={cellList}
        handleEditClick={handleEditClick}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        area={"order-products"}
        selectNames={selectNames}
        setSearchTerm={setSearchTerm}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={purchaseOrdersAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
        rowsPerPageOptions={rowsPerPageOptions}
      />
    );
  }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <Grid
        item
        sm
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 32,
          paddingRight: 32,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              marginRight: 24,
              padding: 0,
              marginLleft: 12,
              fontSize: 24,
              fontWeight: "bold",
              color: "#42494E",
              marginBottom: 0,
              marginTop: 4,
            }}
          >
            Select Client:
          </div>

          <div>
            <FormControl
              style={{ width: 250 }}
              margin="dense"
              className={classes.formControl}
            >
              <Select
                variant="outlined"
                value={client}
                margin="dense"
                onChange={handleChange}
                inputProps={{
                  name: "client",
                  id: "client-simple",
                }}
              >
                {clientsList.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        {/* <div onClick={handleProcessPurchaseOrders}>
          <ColorButton key={client.id} disabled={!client}>
            Process PurchaseOrders
          </ColorButton>
        </div> */}
      </Grid>

      {content}
      <Orders />
    </Grid>
  );
}
